import { SearchOutlined } from '@ant-design/icons';
import { Button, DatePicker, Row, Tag } from 'antd';
import moment from 'moment';
import React from 'react';

import DownloadFilled from '../../../assets/icons/DownloadFilled';
import LocationFilled from '../../../assets/icons/LocationFilled';
import { EditarButton, FiltroInput, Item, SubTitle } from './styles';

const { RangePicker } = DatePicker;

const getColumnSearchProps = () => {
  let searchInput;

  return {
    filterDropdown: filter => (
      <div style={{ padding: 8 }}>
        <FiltroInput
          aria-label="inputSearch"
          ref={node => {
            searchInput = node;
          }}
          value={filter?.selectedKeys?.length ? filter.selectedKeys[0] : ''}
          onChange={e =>
            filter.setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={filter.confirm}
        />
        <Button
          type="primary"
          onClick={filter.confirm}
          icon={<SearchOutlined />}
          style={{ marginRight: 5 }}
        >
          Pesquisar
        </Button>
        <Button className="btn-limpar" onClick={filter.clearFilters}>
          Limpar
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilterDropdownVisibleChange: visible =>
      visible && setTimeout(() => searchInput.select()),
  };
};

const getColumnSearchDataProps = () => {
  const dataFormat = 'YYYY-MM-DDT03:00:00.000';

  const setFormatDate = (value, format = false) => {
    const [dataInicio, dataFim] = value;

    if (format) {
      return [dataInicio.format(dataFormat), dataFim.format(dataFormat)];
    }

    return [moment(dataInicio), moment(dataFim)];
  };

  return {
    filterDropdown: filter => (
      <div style={{ padding: '8px' }}>
        <Row justify="center" align="middle" className="mb-10">
          <RangePicker
            format="DD/MM/YYYY"
            value={
              filter.selectedKeys.length
                ? setFormatDate(filter.selectedKeys)
                : []
            }
            onChange={value =>
              filter.setSelectedKeys(value ? setFormatDate(value, true) : [])
            }
          />
        </Row>
        <Row justify="end">
          <Button
            type="primary"
            onClick={filter.confirm}
            icon={<SearchOutlined />}
            style={{ marginRight: 5 }}
          >
            Pesquisar
          </Button>
          <Button className="btn-limpar" onClick={filter.clearFilters}>
            Limpar
          </Button>
        </Row>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
  };
};

const statusColors = {
  Confirmado: '#FFCA29',
  'Na fila': '#56CCF2',
  Carregando: '#E47515',
  Embarcado: '#6E51E0',
  'Em trânsito': '#24A95D',
  Entregue: '#1271EE',
  Desistiu: '#BF6211',
  Removido: '#D42929',
};

export const getColumns = (
  filters,
  onClickLocalizacao,
  handleShowModalListDocuments
) => [
  {
    title: 'Ações',
    width: '7%',
    align: 'center',
    render: record => (
      <>
        <EditarButton
          type="link"
          disabled={record.status === 'Desistiu'}
          onClick={() => onClickLocalizacao(record)}
        >
          <Item color="#74AA49" size="4px">
            <LocationFilled />
          </Item>
        </EditarButton>
        <EditarButton
          type="link"
          disabled={
            record.status === 'Removido' || record.status === 'Desistiu'
          }
          onClick={() => handleShowModalListDocuments(record)}
        >
          <Item color="#4190F7" size="4px">
            <DownloadFilled />
          </Item>
        </EditarButton>
      </>
    ),
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    width: '10%',
    sorter: true,
    filterMultiple: false,
    filters: [
      { text: 'Em trânsito', value: '1' },
      { text: 'Na fila', value: '3' },
      { text: 'Embarcado', value: '7' },
      { text: 'Entregue', value: '5' },
      { text: 'Desistiu', value: '6' },
      { text: 'Removido', value: '8' },
    ],
    align: 'center',
    render: text => (
      <Tag color={statusColors[text]} key={text}>
        {text}
      </Tag>
    ),
  },
  {
    title: 'Motorista',
    dataIndex: 'nome',
    key: 'nome',
    width: '10%',
    showSorterTooltip: false,
    filteredValue: filters.nome,
    sorter: true,
    align: 'center',
    ...getColumnSearchProps(),
  },
  {
    title: 'Placa',
    dataIndex: 'placaCavalo',
    key: 'placaCavalo',
    width: '10%',
    showSorterTooltip: false,
    filteredValue: filters.placaCavalo,
    sorter: true,
    align: 'center',
    ...getColumnSearchProps(),
  },
  {
    title: 'Data de entrada',
    dataIndex: 'entradaFila',
    key: 'entradaFila',
    width: '11%',
    showSorterTooltip: false,
    filteredValue: filters.entradaFila,
    sorter: true,
    align: 'center',
    render: text => (
      <SubTitle>{moment(text, 'DD-MM-YYYY').format('DD/MM/YYYY')}</SubTitle>
    ),
    ...getColumnSearchDataProps(),
  },
  {
    title: 'Vencimento',
    dataIndex: 'validade',
    key: 'validade',
    width: '11%',
    showSorterTooltip: false,
    filteredValue: filters.validade,
    sorter: true,
    align: 'center',
    render: text => (
      <SubTitle>{moment(text, 'DD-MM-YYYY').format('DD/MM/YYYY')}</SubTitle>
    ),
    ...getColumnSearchDataProps(),
  },
];
